// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__vpuXh","list":"styles_list__v4Mz4","icon":"styles_icon__vkQY5"};